module.exports = __webpack_public_path__ + "static/homepage-hero-mobile-3f40edfc4e15391f28f61bf9031f20af.jpg";